/**
 * SLAY THE SPIRE GAME LOGIC
 * ==========================
 * This file now ONLY exports the unique logic and components for this game.
 * All shared configuration data has been moved to the unified config.
 */

import SlayTheSpireHint from '../../components/SlayTheSpireHint/SlayTheSpireHint';
import CardDirectory from '../../components/CardDirectory/CardDirectory';
import SlayTheSpireHowToPlay from '../../components/SlayTheSpireHowToPlay/SlayTheSpireHowToPlay';

const compareCards = (guessed, target) => {
  const results = {};
  
  // Handle null/undefined inputs
  if (!guessed || !target) {
    return {
      class: 'incorrect',
      type: 'incorrect',
      cost: 'incorrect',
      keyword: 'incorrect',
      target: 'incorrect',
      rarity: 'incorrect'
    };
  }
  
  results.class = guessed.class === target.class ? 'correct' : 'incorrect';
  results.type = guessed.type === target.type ? 'correct' : 'incorrect';

  const normalizeCost = (c) => {
    if (String(c).toUpperCase() === 'X') return -1;
    if (c === -2 || String(c) === "-2") return -2;
    const n = parseInt(c, 10);
    return isNaN(n) ? -99 : n;
  };
  results.cost = normalizeCost(guessed.cost) === normalizeCost(target.cost)
    ? 'correct'
    : 'incorrect';

  const gkw = Array.isArray(guessed.keywords)
    ? guessed.keywords.map(k => k.toLowerCase())
    : [];
  const tkw = Array.isArray(target.keywords)
    ? target.keywords.map(k => k.toLowerCase())
    : [];

  if (!gkw.length && !tkw.length) {
    results.keyword = 'correct';
  } else if (!gkw.length || !tkw.length) {
    results.keyword = 'incorrect';
  } else {
    const common = gkw.filter(k => tkw.includes(k));
    if (common.length === tkw.length && common.length === gkw.length) {
      results.keyword = 'correct';
    } else if (common.length) {
      results.keyword = 'partial';
    } else {
      results.keyword = 'incorrect';
    }
  }

  results.target = guessed.target === target.target ? 'correct' : 'incorrect';
  results.rarity = guessed.rarity === target.rarity ? 'correct' : 'incorrect';

  return results;
};

const getDisplayValue = (card, key) => {
  let val = key === 'keyword' ? card.keywords : card[key];
  if (key === 'keyword') {
    return Array.isArray(val) && val.length ? val.join(', ') : 'None';
  }
  if (val == null || String(val).trim() === '') return 'None';
  if (key === 'cost') {
    const s = String(val).toUpperCase();
    if (s === 'X' || val === -1) return 'X';
    if (val === -2) return 'Unplayable';
  }
  return String(val);
};

const slayTheSpireLogic = {
  // Keep only what is unique to this game
  categories: [
    { key: 'class', label: 'Class' },
    { key: 'type', label: 'Type' },
    { key: 'cost', label: 'Cost' },
    { key: 'keyword', label: 'Card Behavior' },
    { key: 'target', label: 'Target' },
    { key: 'rarity', label: 'Rarity' }
  ],
  compareFunction: compareCards,
  getDisplayValue,
  
  HintComponent: SlayTheSpireHint,
  DirectoryComponent: CardDirectory,
  HowToPlayComponent: SlayTheSpireHowToPlay,
  
  renderVictoryDetails: (card) => (
    <>
      {card.description && (
        <span className="slay-the-spire__card-description">{card.description}</span>
      )}
    </>
  )
};

export default slayTheSpireLogic;